import React, { useState, useEffect } from "react";
import { Waypoint } from 'react-waypoint';
import { Form, Skeleton, Radio, Tag, Input } from 'antd';
import { useQuery } from "@apollo/client";
import { GET_STANDS_CURSOR } from "graphql/query/stand-gql";
import MultiSelect from 'components/layout/form-elements/multi-select';
import { useDebounce } from "components/use-hooks";
import { Loader } from "components/request-result";
import { Localize, cursorPagination, ModalStandard } from 'components/service';
// import './graphic-stand-select.scss';

const GraphicStandSelect = ({
    form,
    initialValue,
    model = "standsCursor",
    name = 'exhibitor',
    loadingQuery,
    disabled = false
}) => {
    const [ searchStand, setSearchStand ] = useState("");
    const initialValueId = initialValue?.id?.toString();
    const [ selectedStandId, setSelectedStandId ] = useState(initialValueId);
    const [ selectedStand, setSelectedStand ] = useState(initialValue);

    useEffect(() => {
        if (initialValue)
        {
            form.setFieldsValue({ [ name ]: initialValue?.exhibitor || '' });
        }
    }, [ initialValue, form, name ]);

    let { data, loading: loadingQueryCursor, fetchMore } = useQuery(GET_STANDS_CURSOR, {
        variables: {
            text: useDebounce(searchStand),
            first: 25,
            exclude_graphics_sent: true,
            whereCrafts: {
                column: 'TYPE',
                operator: 'EQ',
                value: "collect_graphics"
            }
        },
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
    });

    const {
        fetchMoreAction,
        pageInfo,
        node
    } = cursorPagination({
        model,
        data,
        loading: loadingQueryCursor,
        fetchMore
    });

    const StandInfoLabel = ({ stand }) => (
        <div className="stand-info-label">
            <div className="stand-name">{ stand.exhibitor }</div>
            <div className="stand-details">
                <Tag color="blue">Stand №:&nbsp; <strong>{ stand.stand_number || '—' }</strong></Tag>
                <Tag color="cyan">block:&nbsp; <strong>{ stand.block || '—' }</strong></Tag>
                <Tag color="green">corridor:&nbsp; <strong>{ stand.corridor || '—' }</strong></Tag>
                <Tag color="orange">hall:&nbsp; <strong>{ stand.hall_name || '—' }</strong></Tag>
                <Tag color="purple">shelf numb.:&nbsp; <strong>{ stand.shelf_number || '—' }</strong></Tag>
            </div>
        </div>
    );

    const nodes = node
        .filter(({ node }) => node.shelf_number)
        .map(({ node }) => ({
            label: <StandInfoLabel stand={ node } />,
            value: node.id
        }));

    const loading = loadingQueryCursor || loadingQuery;

    const handleRadioChange = (e) => {
        const value = e.target.value;
        setSelectedStandId(value);
        const foundStand = node.find(item => item.node.id === value)?.node || null;

        if (foundStand)
        {
            setSelectedStand(foundStand);

            const formValues = {
                [ name ]: foundStand.exhibitor,
                stand_id: foundStand.id || '',
                shelf_number: foundStand.shelf_number || ''
            };

            form.setFieldsValue(formValues);
        }
    };

    return (
        <Form.Item
            label={ <Localize>FORMS.Input_Label_Exhibitor</Localize> }
            rules={ [
                { required: true, message: <Localize>FORM_RULES.Required_Exhibitor</Localize> }
            ] }
        >
            <Form.Item name={ name } noStyle>
                <Input type="hidden" />
            </Form.Item>

            <ModalStandard
                disabled={ disabled }
                width={ 590 }
                extraClass={ 'modal-form' }
                modalButton={
                    <Input
                        className="cursor-pointer"
                        value={ selectedStand?.exhibitor || initialValue?.exhibitor || '' }
                        placeholder={ Localize({ children: "FORMS.Input_Placeholder_SelectGraphicStand" }).props.children }
                    />
                }
            >
                <strong className="modal-title"><Localize>FORMS.Title_SelectGraphicStand</Localize></strong>
                <MultiSelect
                    setSearch={ setSearchStand }
                    search={ searchStand }
                    placeholder={ Localize({ children: "FORMS.Input_Placeholder_SelectGraphicStand" }).props.children }
                >
                    { loading ? <Skeleton active={ true } paragraph={ { rows: 6 } } /> : (
                        <Radio.Group
                            className="stand-select-group"
                            value={ selectedStandId }
                            onChange={ handleRadioChange }
                        >
                            { nodes.map((option) => (
                                <Radio
                                    key={ option.value }
                                    value={ option.value }
                                    className="stand-radio-option"
                                >
                                    { option.label }
                                </Radio>
                            )) }
                        </Radio.Group>
                    ) }

                    { pageInfo?.hasNextPage &&
                        <>
                            { true && <Loader style={ { marginTop: '-30px' } } /> }
                            <Waypoint onEnter={ () => fetchMoreAction() } />
                        </>
                    }
                </MultiSelect>
            </ModalStandard>
        </Form.Item>
    );
};

export default GraphicStandSelect;